import { Box as MantineBox, BoxProps } from '@mantine/core';

export type IBoxProps = BoxProps;

/** @registry Design-layer pass-through over Mantine Box; import this instead of @mantine/core Box outside src/design. */
export const Box = MantineBox;
